import React from "react";
import GridOrgNameLink from "./GridOrgNameLink";
import { useGridOrgNameNavigation } from "../../custom-hooks/useGridOrgNameNavigation";
import { mapAssessmentDetailsToOrgRow } from "../../utils/gridOrgNameLinks";

/**
 * Vendor org name on VQQ detail banner.
 */
export function RfiDetailBannerVendorName({ details, className = "text-md font-semibold" }) {
  const { navigateToHref, vendorHrefForRfiDetails } = useGridOrgNameNavigation();
  return (
    <GridOrgNameLink
      name={details?.vendorName}
      href={vendorHrefForRfiDetails(details)}
      onNavigate={navigateToHref}
      className={className}
    />
  );
}

function resolveAssessmentBannerVendorName(details) {
  const mapped = mapAssessmentDetailsToOrgRow(details);
  return (
    mapped.provider_name ??
    details?.provider?.provider_name ??
    details?.vqa?.provider?.provider_name
  );
}

function resolveAssessmentBannerSponsorName(details) {
  const mapped = mapAssessmentDetailsToOrgRow(details);
  if (mapped.sponsor_name) return mapped.sponsor_name;
  const primary = (details?.vqa_request_sponsors ?? []).find(
    (s) => s?.is_primary_sponsor === true
  );
  return primary?.sponsor_name ?? details?.sponsor_name ?? "";
}

/**
 * Vendor + primary sponsor org names on VQA detail banners.
 */
export function AssessmentDetailBannerOrgNames({
  details,
  vendorClassName = "text-sm text-gray-500 break-words",
  sponsorClassName = "font-semibold text-md",
  showVendor = true,
  showSponsor = true,
}) {
  const {
    navigateToHref,
    vendorHrefForAssessmentDetails,
    sponsorHrefForAssessmentDetails,
  } = useGridOrgNameNavigation();

  // The href helpers map the raw details themselves; mapping twice drops the Discovery flag.
  return (
    <>
      {showVendor ? (
        <GridOrgNameLink
          name={resolveAssessmentBannerVendorName(details)}
          href={vendorHrefForAssessmentDetails(details)}
          onNavigate={navigateToHref}
          className={vendorClassName}
        />
      ) : null}
      {showSponsor ? (
        <GridOrgNameLink
          name={resolveAssessmentBannerSponsorName(details)}
          href={sponsorHrefForAssessmentDetails(details)}
          onNavigate={navigateToHref}
          className={sponsorClassName}
        />
      ) : null}
    </>
  );
}
